module.exports = __webpack_public_path__ + "img/r-195.e243d1c4.jpg";